export const getAnsweredTime = (time_to_end: number) => {
	return Math.round(time_to_end / 1000) || 1;
};

export const HERDS_MESSAGES = {
	question_start: `Hey Captain, it’s up to you 
				to make sure you answer the question
				 before the countdown ends. Get your team to
				  help you.`,
	team_created: `Congratulations, your
	 team has been created! Invite your
	  friends by giving them the invite code.`,
	team_updated: `Team has been updated`,
	team_revived: `Team has been revived`,
	team_removed: `Team has been removed`,
	captain_changed: `Captain has been changed'`,
	joined_player: `A player has joined your team`,
	player_left: `A player has left`,
	player_was_removed: `A player has been removed`,
	captain_team_updated: `Congratulations, your team has been updated!`,
	you_left_team: `You have left the team`,
	you_joined: `You have joined the team`,
	you_revive_joined: `Congratulations, you have successfully joined your revived team`,
	you_revive_joined_captain: `Congratulations, your
	 team has been revived. You are the first team member
	  to revive it and are now the Captain!`,
	you_was_removed: `You have been removed from the team`
}